import type {ActionResponse, ExactUserRawBodyMailSendRequest, RawBodyMailSendRequest} from 'src/typings';
import {transferify} from '../utils/data-service-utils';
import type {AjaxService} from 'core/data-services/ajax.service';

export class MailerDataService {
    public static serviceName = 'mailerDataService';

    private readonly MAIL_ROUTE = 'mail';
    private readonly EXACT_USER_MAIL_ROUTE = 'mail/exact-user';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async sendMailToExactUsers(request: ExactUserRawBodyMailSendRequest) {
        return this.ajaxService
            .createRequest(this.EXACT_USER_MAIL_ROUTE)
            .post<ActionResponse>(transferify(request));
    }

    public async sendMail(request: RawBodyMailSendRequest) {
        return this.ajaxService
            .createRequest(this.MAIL_ROUTE)
            .post<ActionResponse>(transferify(request));
    }
}
